import { useId } from 'react'
import { Button } from '../../platform/primitives/Button'
import { PAGE_SIZE } from './filters'
import type { TxnPage } from './useTransactions'

export function rangeOf(p: TxnPage, pageSize = PAGE_SIZE): { from: number; to: number } {
  const from = (p.page - 1) * pageSize + 1
  return { from, to: from + p.rows.length - 1 }
}

/** `pageSize` is the size the list was fetched at: `/transactions` pages by 50, a cashflow drill-down by 100. */
export function Pager({
  page,
  fetching,
  onPage,
  pageSize = PAGE_SIZE,
}: {
  page: TxnPage
  fetching: boolean
  onPage: (n: number) => void
  pageSize?: number
}) {
  const id = useId()
  const { from, to } = rangeOf(page, pageSize)
  const first = page.page <= 1
  const last = !page.hasMore
  return (
    <footer className="txn-pager">
      <span className="txn-pager__range">
        {page.rows.length === 0 ? `Showing 0 of ${page.total}` : `Showing ${from}–${to} of ${page.total}`}
        {fetching && <span className="txn-pager__updating"> · Updating…</span>}
      </span>
      <span className="txn-pager__buttons">
        <Button
          size="panel"
          disabled={first}
          aria-describedby={first ? `${id}-first` : undefined}
          onClick={() => onPage(page.page - 1)}
        >
          Previous
        </Button>
        <Button
          size="panel"
          disabled={last}
          aria-describedby={last ? `${id}-last` : undefined}
          onClick={() => onPage(page.page + 1)}
        >
          Next
        </Button>
        {first && (
          <span id={`${id}-first`} className="sr-only">
            You are on the first page
          </span>
        )}
        {last && (
          <span id={`${id}-last`} className="sr-only">
            You are on the last page
          </span>
        )}
      </span>
    </footer>
  )
}
